import React, { useEffect, useState } from "react";
import {
  Container,
  CreateContainer,
  StyledForm,
  StyledFormElementsWrapper,
  Button,
} from "./styles";
import ActionBar from "../../common/ActionBar";
import { Formik } from "formik";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage, getFileName } from "../../../helpers/functions";
import AWSService from "../../../services/AWSService";
import {
  PrimaryOutlinedCTAButton,
  PrimaryCTAButton,
} from "../../common/Buttons";
import UploadNotice from "./component/UploadNotice";
import GenerateNotice from "./component/GenerateNotice";
import { NoticeGenerationSchema } from "../../../helpers/validationSchema";
import NoticeService from "../../../services/NoticeService";
import HeaderFooter from "./component/HeaderFooter";
import { navigate } from "@reach/router";
import UpdateNotice from "./component/UpdateNotice";
import NoticeDesign from "./component/NoticeDesign";
import useUser from "../../../hooks/useUser";
import Axios from "axios";
import ValidationErrors from "./component/ValidationError";
import AddSignature from "./component/AddSign";
import TemplateDelete from "./component/TemplateDelete";

import {
  FormControl,
  FormLabel as MuiFormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

const NoticeGeneration = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [menuNotice, setMenuNotice] = useState([]);
  const [menuTemplateCode, setMenuTemplateCode] = useState([]);
  const [menuHeaderFooter, setMenuHeaderFooter] = useState([]);
  const [letterHeadArr, setLetterHeaderArr] = useState([]);
  const [find, setFind] = useState(false);
  const [letterMenuItems, setLetterMenuItems] = useState([]);
  const [triggerNotify, setTriggerNotify] = useState(true);
  const [noticeDesign, setNoticeDesign] = useState({});
  const [noticeDesignTemplate, setNoticeDesignTemplate] = useState({});
  const { userObject } = useUser();
  const [modal, setModal] = useState({ state: false });
  const [options, setOptions] = useState(
    userObject?.isSuperCaseManager ? 1 : 2,
  );

  useEffect(() => {
    setOptions(userObject?.isSuperCaseManager ? 1 : 2); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject]);

  async function getNoticeTemplates(partyId) {
    try {
      setLoader({ state: true, message: "fetching notice details..." });
      const response = await NoticeService.getNoticeTemplates(partyId);
      if (response[0]) {
        setMenuNotice(
          response[0]?.noticeCategory?.map((item) => ({
            label: item,
            value: item,
          })),
        );
        setMenuTemplateCode(response[0]?.codeAndTemplates);
        const arrayOfObject = response[0]?.letterHeadArr.map((item) => ({
          label: item,
          value: item,
        }));
        setMenuHeaderFooter([{ label: "None", value: "" }, ...arrayOfObject]);
        setLetterHeaderArr(response[0]?.letterHeadOption);
        setNoticeDesignTemplate(response[0]?.designData?.designData);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  async function getNoticeDesign(partyId) {
    try {
      setLoader({ state: true, message: "fetching notice details..." });
      const response = await NoticeService.getNoticeDesign(partyId);
      if (Object.keys(response?.designData || {}).length) {
        setNoticeDesign({ partyId: partyId, ...response?.designData });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const checkbox_actions = [
    {
      label: "Create",
      name: "create",
      value: 1,
      hidden: userObject?.isSuperCaseManager ? false : true || true,
    },
    {
      label: "Update",
      name: "update",
      value: 4,
      hidden: userObject?.isSuperCaseManager ? false : true || true,
    },
    { label: "Generate", name: "generate", value: 2 },
    {
      label: "Add Letter Head",
      name: "headerFooterOptions",
      value: 3,
    },
    {
      label: "Notice design",
      name: "noticeDesign",
      value: 5,
    },
    {
      label: "Add Signature",
      name: "addSignature",
      value: 6,
    },
    {
      label: "Delete",
      name: "templatedCodeDelete",
      value: 7,
      hidden: userObject?.isSuperCaseManager ? false : true || true,
    },
  ];

  const inputs = [
    {
      type: "text",
      name: "noticeCategory",
      label: "Notice Category",
      required: true,
    },
    {
      type: "text",
      name: "templateCode",
      label: "Template Code",
      required: true,
    },
  ];

  const radio_inputs = [
    {
      label: "Image",
      name: "image",
      value: "image",
    },
    {
      label: "Text",
      name: "text",
      value: "text",
    },
  ];

  const upload_templates = [
    {
      name: "noticeTemplate",
      label: "Upload Notice Template (docx)",
      type: "upload",
      required: true,
      accept: ".docx",
      types: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ],
    },
    {
      name: "excelTemplate",
      label: "Upload Excel Template (xlsx)",
      type: "upload",
      required: true,
      accept: ".xlsx",
      types: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ],
    },
  ];

  async function s3Upload(file, field, setFieldValue, fileTypes) {
    if (file) {
      try {
        const types = fileTypes;
        setLoader({ state: true, message: `Uploading file ${file.name}` });
        const errorMessage = "Invalid File Type";
        if (!types.includes(file?.type)) throw errorMessage;
        const payload = {
          key: file.name,
        };
        const maxSize = 3 * 1024 * 1024;
        if (file.size > maxSize) {
          enqueueSnackbar("File size must be less than or equal to 3MB", {
            variant: "error",
          });
          return;
        }
        let fileNameWithoutExt = file.name.replace(
          /\s*\.(xlsx|pdf|docx)$/i,
          "",
        );
        const hasSpecialChar = /[^a-zA-Z0-9\s-_]/.test(fileNameWithoutExt);
        if (hasSpecialChar) {
          enqueueSnackbar("Filename contains invalid special characters", {
            variant: "error",
          });
        } else {
          const s3Response = await AWSService.getS3URL(payload);
          if (s3Response.url) {
            const res = await AWSService.uploadToS3(s3Response.url, file);
            setFieldValue(field, res);
          }
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        setLoader({ state: false });
      }
    }
  }

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true, message: "please wait..." });
      if (values?.noticeOptions === 1) {
        const payload = {
          partyId: values?.partyId,
          noticeCategory: values?.noticeCategory,
          templateCode: values?.templateCode,
          excelTemplate: values?.excelTemplate,
          noticeTemplate: values?.noticeTemplate,
        };
        const response = await NoticeService.uploadNoticeTemplates(payload);
        if (response) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
          resetForm();
        }
        setOptions(values?.noticeOptions);
      } else if (values?.noticeOptions === 2) {
        let noticeDesign =
          values?.noticeCopyDesign === "default"
            ? {
                lineSpacing: values?.lineSpacing,
                afterLineSpacing: values?.afterLineSpacing,
                topMargin: values?.topMargin,
                bottomMargin: values?.bottomMargin,
                leftMargin: values?.leftMargin,
                rightMargin: values?.rightMargin,
                headerDistance: values?.headerDistance,
                footerDistance: values?.footerDistance,
                fontSize: values?.fontSize,
              }
            : noticeDesignTemplate;

        const source =
          values?.letterHeadName &&
          letterHeadArr[values?.letterHeadName]?.length &&
          letterHeadArr[values?.letterHeadName][0];
        let letterHeadPayload;
        if (source) {
          if (source.letterHeadType === "image") {
            letterHeadPayload = {
              id: source.id,
              headerImage: source.headerImage || "",
              footerImage: source.footerImage || "",
              letterHeadType: "image",
            };
          } else if (source.letterHeadType === "text") {
            letterHeadPayload = {
              id: source.id,
              letterHeadType: "text",
              headerFooterText: {
                headerText: source.headerFooterText?.headerText || [],
                footerText: source.headerFooterText?.footerText || [],
              },
              headerAlignment: values?.headerAlignment || "left",
              footerAlignment: values?.footerAlignment || "left",
            };
          }
        } else {
          letterHeadPayload = { headerImage: "", footerImage: "" };
        }

        let noticeTemplatePayload = menuTemplateCode[
          values?.noticeCategory
        ].filter(
          (template) => template?.templateCode === values?.templateCode,
        )[0]?.noticeTemplate;

        const payload = {
          partyId: values?.partyId,
          noticeCategory: values?.noticeCategory,
          templateCode: values?.templateCode,
          excelFile: values?.excelFile,
          lotNo: values?.lotNo,
          // checkerId: values?.checkerId,
          noticeTemplate: noticeTemplatePayload,
          letterHeadName: values?.letterHeadName,
          letterHeadImages: letterHeadPayload,
          noticeDesign,
          codeType: values?.codeType,
          arbitratorName: values?.arbitratorName,
          institutionName: values?.institutionName,
          loanType: values?.loanType,
          loanStatus: values?.loanStatus,
        };

        const res = await Axios.post(
          "https://mod.justact.co.in/check-keyerror",
          {
            noticeTemplate: noticeTemplatePayload,
            excelFile: values?.excelFile,
          },
        );
        if (res.data.message) {
          const response = await NoticeService.bulkNoticeGenerate(payload);
          if (response?.message) {
            enqueueSnackbar(response?.message, {
              variant: "success",
            });
            resetForm();
          }
          setOptions(values?.noticeOptions);
        } else {
          setModal({ state: true, metaData: res.data });
        }
      } else if (values?.noticeOptions === 3) {
        const payload = {
          letterHeadName: values?.letterHeadName,
          headerImage: values?.headerImage,
          footerImage: values?.footerImage,
          typeOfLetterHead: values?.typeOfLetterHead,
          headerText: values?.headerText,
          footerText: values?.footerText,
        };
        if (find) {
          const response = await NoticeService.addLetterHeadOption(payload);
          if (response?.message) {
            enqueueSnackbar(response?.message, {
              variant: "success",
            });
            setTriggerNotify(true);
            resetForm();
          }
          setOptions(values?.noticeOptions);
        } else {
          let id = await letterMenuItems.filter(
            (item) => values?.letterHeadName === item.label,
          )[0]?.id;
          const response = await NoticeService.updateLetterHeadOption(
            payload,
            id,
          );
          if (response?.message) {
            enqueueSnackbar(response?.message, {
              variant: "success",
            });
            resetForm();
          }
          setOptions(values?.noticeOptions);
        }
      } else if (values?.noticeOptions === 4) {
        const payload = {
          noticeCategory: values?.noticeCategory,
          templateCode: values?.templateCode,
          excelTemplate: values?.excelTemplate,
          noticeTemplate: values?.noticeTemplate,
        };
        let id = await menuTemplateCode[values?.noticeCategory].filter(
          (templateCode) => templateCode?.templateCode === values?.templateCode,
        )[0]?.id;
        const response = await NoticeService.updateNoticeTemplates(payload, id);
        if (response) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
          resetForm();
        }
        setOptions(values?.noticeOptions);
      } else if (values?.noticeOptions === 5) {
        const payload = {
          designData: {
            lineSpacing: values?.lineSpacing,
            afterLineSpacing: values?.afterLineSpacing,
            topMargin: values?.topMargin,
            bottomMargin: values?.bottomMargin,
            leftMargin: values?.leftMargin,
            rightMargin: values?.rightMargin,
            headerDistance: values?.headerDistance,
            footerDistance: values?.footerDistance,
            fontSize: values?.fontSize,
          },
        };
        setNoticeDesign({
          partyId: values?.partyId,
          lineSpacing: values?.lineSpacing,
          afterLineSpacing: values?.afterLineSpacing,
          topMargin: values?.topMargin,
          bottomMargin: values?.bottomMargin,
          leftMargin: values?.leftMargin,
          rightMargin: values?.rightMargin,
          headerDistance: values?.headerDistance,
          footerDistance: values?.footerDistance,
          fontSize: values?.fontSize,
        });
        const response = await NoticeService.updateNoticeDesign(
          values?.partyId,
          payload,
        );
        if (response) {
          enqueueSnackbar(response?.message, {
            variant: "success",
          });
          resetForm();
        }
        setOptions(values?.noticeOptions);
      } else if (values?.noticeOptions === 6) {
        let formData = new FormData();
        formData.append("files", values?.addSignature);
        const response = await fetch(
          `https://mod.justact.co.in/upload-signature`,
          {
            method: "POST",
            body: formData,
          },
        );
        if (response.ok) {
          const data = await response.json();
          enqueueSnackbar(data.message, {
            variant: "success",
          });
          resetForm();
        }
      } else if (values?.noticeOptions === 7) {
        let id = menuTemplateCode[values?.noticeCategory]?.filter(
          (template) => template?.templateCode === values?.templateCode,
        )[0]?.id;

        if (!id) {
          enqueueSnackbar("Please select a valid template to delete", {
            variant: "error",
          });
          return;
        }
        const payload = {
          partyId: values?.partyId,
          noticeCategory: values?.noticeCategory,
          templateCode: values?.templateCode,
          deleteFlag: true,
        };
        const response = await NoticeService.deleteNoticeTemplate(payload, id);
        if (response?.message) {
          enqueueSnackbar("Notice template deleted successfully", {
            variant: "success",
          });
          resetForm();
        }
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setFind(false);
    }
  }

  return (
    <>
      <ActionBar breadcrumbs={["Notice Generation"]} />
      <Container>
        <CreateContainer className="CreateCase"></CreateContainer>
        <Formik
          initialValues={{
            noticeOptions: options || "",
            noticeCategory: "",
            templateCode: "",
            letterHeadName: "",
            lotNo: "",
            noticeTemplate: "",
            // checkerId: "",
            excelTemplate: "",
            partyId: noticeDesign?.partyId || "",
            excelFile: "",
            headerImage: "",
            footerImage: "",
            noticeCopyDesign: "",
            lineSpacing: noticeDesign?.lineSpacing || 10,
            afterLineSpacing: noticeDesign?.afterLineSpacing || 1,
            topMargin: noticeDesign?.topMargin || 2.25,
            bottomMargin: noticeDesign?.bottomMargin || 1.25,
            leftMargin: noticeDesign?.leftMargin || 1.5,
            rightMargin: noticeDesign?.rightMargin || 1.5,
            headerDistance: noticeDesign?.headerDistance || 0.25,
            footerDistance: noticeDesign?.footerDistance || 0.25,
            fontSize: noticeDesign?.fontSize || 10,
            codeType: "",
            arbitratorName: "",
            institutionName: "",
            loanType: "",
            loanStatus: "",
            typeOfLetterHead: "image",
            headerText: [""],
            footerText: [""],
            headerAlignment: 1,
            footerAlignment: 1,
            addSignature: "",
            templatedCodeDelete: "",
          }}
          validationSchema={NoticeGenerationSchema}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            handleChange,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldError,
            resetForm,
          }) => (
            <StyledForm>
              <StyledFormElementsWrapper
                style={{ marginBottom: 15, marginTop: 15, maxWidth: "100%" }}
              >
                <MuiFormLabel
                  component="legend"
                  style={{
                    fontFamily: "openSans-SemiBold, sans-serif",
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#293461",
                    marginBottom: 16,
                  }}
                >
                  Select Notice Operation
                </MuiFormLabel>

                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    row
                    name="noticeOptions"
                    value={options}
                    onChange={(e) => {
                      const selectedValue = Number(e.target.value);
                      setOptions(selectedValue);
                      setFieldValue("noticeOptions", selectedValue);

                      if (selectedValue !== 5) {
                        setFind(false);
                        resetForm();
                        setNoticeDesign({});
                      } else {
                        setFind(false);
                        resetForm();
                      }
                    }}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "20px",
                      justifyContent: "flex-start",
                    }}
                  >
                    {checkbox_actions
                      .filter((item) => !item.hidden)
                      .map((item) => (
                        <FormControlLabel
                          key={item.value}
                          value={item.value}
                          control={
                            <Radio
                              color="primary"
                              style={{
                                color: "#00838c",
                              }}
                            />
                          }
                          label={
                            <span
                              style={{
                                fontFamily: "openSans-SemiBold, sans-serif",
                                fontSize: "17px",
                                color: "#293461",
                              }}
                            >
                              {item.label}
                            </span>
                          }
                          style={{
                            marginRight: 0,
                            width: "auto",
                          }}
                        />
                      ))}
                  </RadioGroup>
                </FormControl>
              </StyledFormElementsWrapper>
              {values?.noticeOptions === 1 ? (
                <UploadNotice
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    inputs,
                    upload_templates,
                    s3Upload,
                    getFileName,
                  }}
                />
              ) : values?.noticeOptions === 2 ? (
                <GenerateNotice
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    inputs,
                    upload_templates,
                    s3Upload,
                    getFileName,
                    menuNotice,
                    menuTemplateCode,
                    menuHeaderFooter,
                    getNoticeTemplates,
                  }}
                  cmId={userObject?.id}
                  radioInputs={radio_inputs}
                />
              ) : values?.noticeOptions === 3 ? (
                <HeaderFooter
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    setFieldValue,
                    setFind,
                    letterMenuItems,
                    setLetterMenuItems,
                    triggerNotify,
                    setTriggerNotify,
                  }}
                  radioInputs={radio_inputs}
                />
              ) : values?.noticeOptions === 4 ? (
                <UpdateNotice
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    inputs,
                    upload_templates,
                    s3Upload,
                    getFileName,
                    menuNotice,
                    menuTemplateCode,
                    getNoticeTemplates,
                  }}
                />
              ) : values.noticeOptions === 5 ? (
                <NoticeDesign
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    setFieldValue,
                    inputs,
                  }}
                  getNoticeTemplates={getNoticeDesign}
                />
              ) : values?.noticeOptions === 6 ? (
                <AddSignature
                  {...{
                    values,
                    errors,
                    touched,
                    setFieldValue,
                  }}
                />
              ) : values?.noticeOptions === 7 ? (
                <TemplateDelete
                  {...{
                    values,
                    handleChange,
                    errors,
                    touched,
                    handleBlur,
                    setFieldValue,
                    menuNotice,
                    menuTemplateCode,
                    menuHeaderFooter,
                    getNoticeTemplates,
                  }}
                  cmId={userObject?.id}
                />
              ) : null}
              <StyledFormElementsWrapper
                style={{
                  float: "right",
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                  marginTop: 15,
                  width: "45%",
                }}
              >
                <Button
                  style={{
                    marginLeft: "unset",
                  }}
                >
                  <PrimaryOutlinedCTAButton
                    onClick={() => navigate(`/dashboard/case-manager`)}
                  >
                    Back
                  </PrimaryOutlinedCTAButton>
                </Button>
                <Button style={{ marginLeft: "22px" }}>
                  <PrimaryCTAButton
                    onClick={() => {
                      if (values?.noticeOptions === 7) {
                        console.log(
                          "DELETE SUBMIT TRIGGERED (validation bypassed)",
                        );
                        onFormSubmit(values, { resetForm });
                      } else {
                        handleSubmit();
                      }
                    }}
                  >
                    {values?.noticeOptions === 1
                      ? "Upload"
                      : values?.noticeOptions === 2
                        ? "Generate Notice"
                        : values?.noticeOptions === 5
                          ? "Create Design"
                          : values?.noticeOptions === 7
                            ? "Delete"
                            : values?.noticeOptions === 3
                              ? find
                                ? "Add"
                                : "Update"
                              : "Update"}
                  </PrimaryCTAButton>
                </Button>
              </StyledFormElementsWrapper>
            </StyledForm>
          )}
        </Formik>
      </Container>
      {modal?.state && <ValidationErrors {...{ modal, setModal }} />}
    </>
  );
};

export default NoticeGeneration;
